export const feedbackVariants = {
    Success: 'text-feedback-success-500',
    Error: 'text-feedback-negative',
    Warning: 'text-feedback-warning-500'
}

export const feedbackIconVariants = {
    Success: 'fill-feedback-success-500',
    Error: 'fill-feedback-negative',
    Warning: 'fill-feedback-warning-500'
}